<template>
  <div>
    <!-- Modal loadingModal -->
    <div class="modal fade" ref="loadingModal" data-backdrop="static" data-keyboard="false" tabindex="-1" :aria-labelledby="$id('loadingLabel')" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title heading text-black" :id="$id('loadingLabel')">Connecting to Payment Platform</h4>
                <br>
                <div id="lockingError" class="text-black text-left">
                  <p>If you are using Internet Explorer or the spinner keeps on spinning, there has been some kind of error (get Bill Gates in here!).</p>
                  <p class="mb-0">Please refresh and try again, or <a :href="contactRoute" class="font-weight-bold">Contact Us</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col" id="ajaxImg">
                <img class="mx-auto d-block" src="/img/ajax_lg.gif" alt="Awaiting server to retrieve the information"> <!-- TODO: see if we can use the Vue Loading spinner -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal loadingModal -->

    <!-- Modal voucherModal -->
    <div class="modal fade text-left text-black" ref="voucherModal" tabindex="-1" data-backdrop="static" aria-labelledby="voucherLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="modal-header">
            <h4 v-if="$deploymentIs('cryptology')" class="modal-title heading" id="voucherLabel">Cryptology {{ location.name }} Gift Certificate</h4>
            <h4 v-else-if="$deploymentIs('breakescape')" class="modal-title font-weight-bold" id="voucherLabel">{{ brand }} Gift Voucher</h4>
            <h4 v-else-if="$deploymentIs('topescaperooms')" class="modal-title font-weight-bold" id="voucherLabel">Kidderminster Gift Voucher</h4>
            <h4 v-else class="modal-title font-weight-bold" id="voucherLabel">{{ brand }} Gift Voucher</h4>
            <button type="button" class="close btn-red" data-dismiss="modal" aria-label="Close">
              <h4 aria-hidden="true">&times;</h4>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <h3 id="modal-room-name" class="heading">Gift {{ voucherDescription }}</h3>

                <h5>Please enter the details carefully below&hellip;</h5>
              </div>
              <div class="col-sm-4">
                <img :src="location.mpVoucherLandscapeSrc" class="img-fluid">
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label" for="sendToCustomer">
                {{ sendType }} To Me
              </label>
              <div class="col-sm-2">
                <div class="checkboxdiv">
                  <label class="checkboxdiv-label-lg">
                    <input
                      type="checkbox"
                      id="sendToCustomer"
                      v-model="sendToCustomer">
                    <span class="cr"><span class="cr-icon">&#10004;</span></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="alert alert-yellow">
                  <template v-if="sendBy == 'P'">
                    <template v-if="sendToCustomer">
                      <p class="mb-0">Please ensure your address is accurate when you pay for the item.</p>

                      <textarea
                        v-model="postAddress"
                        class="form-control"
                        :class="{'is-invalid': postAddressError}"
                        row="4"
                        placeholder="Address here..."></textarea>
                      <div v-if="postAddressError" class="invalid-feedback d-block" role="alert">{{ postAddressError }}</div>
                    </template>
                    <template v-else>
                      <p class="mb-0">You will enter the recipient's address on the next screen.</p>
                    </template>
                  </template>
                  <template v-else>
                    <p class="mb-0">Please ensure <b><i>your</i></b> email address is accurately entered.</p>
                    <p class="mb-0" v-if="! sendToCustomer">You will enter their details on the next screen</p>
                  </template>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('email')" class="col-sm-2 col-form-label">My Email</label>
              <div class="col-sm-10">
                <input
                  type="email"
                  :id="$id('email')"
                  class="form-control"
                  :class="{'is-invalid': emailError}"
                  placeholder="If you have already booked before, your email will populate the rest"
                  v-model="email"
                  @blur='emailBlur'
                  autocomplete="emial"
                  required>
                  <div v-if="emailError" class="invalid-feedback d-block" role="alert">{{ emailError }}</div>
                  <div v-if="emailSoftError" class="text-orange font-weight-bold d-block" role="alert">{{ emailSoftError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('name')" class="col-sm-2 col-form-label">My Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  :id="$id('name')"
                  ref="nameInput"
                  class="form-control"
                  :class="{'is-invalid': nameError}"
                  v-model="name"
                  placeholder="Your name"
                  autocomplete="name"
                  required>
                  <div v-if="nameError" class="invalid-feedback d-block" role="alert">{{ nameError }}</div>
              </div>
            </div>

            <div class="form-group row" style="display: none;">
              <label :for="$id('username')" class="col-sm-2 col-form-label">Username</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  :id="$id('username')"
                  class="form-control"
                  v-model="username"
                  placeholder="Username"
                  autocomplete="off">
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('contactNumber')" class="col-sm-2 col-form-label">My Contact</label>
              <div class="col-sm-10">
                <input
                  type="tel"
                  :id="$id('contactNumber')"
                  ref="customerTelephoneInput"
                  class="form-control"
                  :class="{'is-invalid': contactNumberError}"
                  v-model="contactNumber"
                  placeholder="Your contact number"
                  autocomplete="tel"
                  required>
                  <div v-if="contactNumberError" class="invalid-feedback d-block" role="alert">{{ contactNumberError }}</div>
              </div>
            </div>

            <div v-if="false" class="form-group row"> <!-- // TODO -->
              <label :for="$id('discount')" class="col-sm-2 col-form-label">Discount Code</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  :id="$id('discount')"
                  class="form-control"
                  :class="{'is-invalid': discountError}"
                  v-model="discount"
                  placeholder="Discount Code Here">
                  <div v-if="discountError" class="invalid-feedback d-block" role="alert">{{ discountError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('total')" class="col-sm-2 col-form-label">Amount</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  readonly class="form-control-plaintext font-weight-bold"
                  :id="$id('total')"
                  :value="$money(voucherPreDiscountedTotal)">
              </div>
            </div>

            <div class="form-group row">
              <span class="col-sm-2 col-form-label">Method</span>
              <div class="col-sm-10">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    v-model="sendBy"
                    name="sendBy"
                    :id="$id('methodE')"
                    :checked="isDecember && isAfterPostCutoff"
                    value="E"
                    checked>
                    <label class="form-check-label" :for="$id('methodE')">Email</label>
                  <br>
                  <template v-if="sellPostalVoucher">
                    <input
                      class="form-check-input"
                      type="radio"
                      v-model="sendBy"
                      name="sendBy"
                      :id="$id('methodP')"
                      :disabled="isDecember && isAfterPostCutoff"
                      value="P">
                      <label class="form-check-label" :for="$id('methodP')">Post</label>
                  </template>
                  <template v-if="collectVoucher">
                    <br>
                    <input
                      class="form-check-input"
                      type="radio"
                      v-model="sendBy"
                      name="sendBy"
                      :id="$id('methodI')"
                      value="I">
                      <label class="form-check-label" :for="$id('methodI')">Collect</label>
                  </template>
                </div>
              </div>
            </div>

            <div v-if="isDecember && isAfterPostCutoff" class="alert alert-warning" role="alert">
              <div class="input-group input-group-lg row">
                <div class="col-sm-1">
                  <i class="material-icons" aria-hidden="true">forward_to_inbox</i>
                </div>
                <div class="col-sm-11">
                  <p class="mb-0">
                    We are past Royal Mail postal cutoff for Christmas delivery.
                    Only email vouchers can be purchased (unless you contact us)
                  </p>
                </div>
              </div>
            </div>

            <div class="alert alert-danger" role="alert">
              <div class="input-group input-group-lg row">
                <div class="col-sm-1">
                  <i class="material-icons" aria-hidden="true">error</i>
                </div>
                <div class="col-sm-11">
                  <p class="mb-0">Any discounts will be calculated on the next screen.</p>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Choose a different voucher</button>
            <button
              v-if="sendToCustomer"
              id="voucherSaleConfirmPriceBtn"
              type="button"
              class="btn btn-green"
              @click="confirmPriceClick()">
              Confirm Price
            </button>
            <button
              v-else
              id="recipientDetailsBtn"
              type="button"
              class="btn btn-purple"
              @click="recipientDetailsClick()">
              Enter Recipient's Details
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal voucherModal -->

    <!-- Modal recipientModal -->
    <div class="modal fade text-left text-black" ref="recipientModal" tabindex="-1" aria-labelledby="recipientsDetails" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title heading" id="recipientsDetails">Recipient's Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-yellow">
              You have selected {{ sendBy == 'P' ? 'a postal' : 'an email' }} gift voucher for somebody else. Please enter their details below&hellip;
            </div>
            <div class="form-group row">
              <label :for="$id('recipientEmail')" class="col-sm-3 col-form-label">Recipient Email</label>
              <div class="col-sm-9">
                <input
                  type="email"
                  :id="$id('recipientEmail')"
                  class="form-control"
                  :class="{'is-invalid': recipientEmailError}"
                  placeholder="Their email address"
                  v-model="recipientEmail">
                <div v-if="recipientEmailError" class="invalid-feedback d-block" role="alert">{{ recipientEmailError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('recipientName')" class="col-sm-3 col-form-label">Recipient Name</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  :id="$id('recipientName')"
                  class="form-control"
                  :class="{'is-invalid': recipientNameError}"
                  v-model="recipientName"
                  placeholder="Recipient's Name">
                <div v-if="recipientNameError" class="invalid-feedback d-block" role="alert">{{ recipientNameError }}</div>
              </div>
            </div>

            <div class="form-group row" v-if="type == 'P'">
              <label :for="$id('postAddress')" class="col-sm-3 col-form-label">{{ sendToCustomer ? 'My' : 'Recipient' }} Address</label>
              <div class="col-sm-9">
                <textarea
                  :id="$id('postAddress')"
                  rows="4"
                  class="form-control"
                  :class="{'is-invalid': postAddressError}"
                  v-model="postAddress"
                  placeholder="Full UK Address..."></textarea>
                  <div v-if="postAddressError" class="invalid-feedback d-block" role="alert">{{ postAddressError }}</div>
              </div>
            </div>

            <div class="form-group row">
              <label :for="$id('recipientMessage')" class="col-sm-3 col-form-label">Personalised Message</label>
              <div class="col-sm-9">
                <textarea
                  :id="$id('recipientMessage')"
                  rows="3"
                  class="form-control"
                  v-model="recipientMessage"
                  placeholder="This is optional..."></textarea>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-yellow"
              @click="backToVoucherModal()">
              Back To My Details
            </button>
            <button
              type="button"
              class="btn btn-green"
              @click="confirmPriceClick()">
              Confirm Price
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal confirmModal -->
    <div class="modal fade text-left text-black" ref="confirmModal" tabindex="-1" aria-labelledby="comfirmModealLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div v-if="'CONFIRMING' == state" class="modal-content">
          <div class="modal-header">
            <h4 v-if="$deploymentIs('cryptology')" class="modal-title heading" id="comfirmModealLabel">Cryptology {{ location.name }} Payment</h4>
            <h4 v-else-if="$deploymentIs('breakescape')" class="modal-title font-weight-bold" id="comfirmModealLabel">{{ brand }} {{ location.name }} Payment</h4>
            <h4 v-else class="modal-title font-weight-bold" id="comfirmModealLabel">{{ brand }} Payment</h4>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col">
                <input id="payEmail" type="hidden">
                <div class="alert alert-info" role="alert">
                  <h4>You are about to purchase&hellip;</h4>
                  <ul>
                    <li><strong>Voucher:</strong> <span>{{ voucherDescription }}</span></li>
                    <li><strong>For:</strong> <span>{{ voucherPreDiscountedTotal | money }}</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="alert alert-success" role="alert">
                      <div class="input-group input-group-lg">
                        <h4> <!-- TODO: this actually needs to be the Discounted Price -->
                          Total Cost: <strong>{{ voucherPostDiscountedTotal | money }}</strong>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
                      <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click="payButtonClicked"
                        :disabled="payButtonDisable">
                        PAY
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div v-if="asPendingError" class="alert alert-danger" role="alert" id="slot_book_lock">
                  <div class="input-group">
                    <p>{{ asPendingError }}</p>
                    <button type="button" class="btn btn-danger btn-block" data-dismiss="modal">Choose a different voucher</button>
                  </div>
                </div>
                <div v-else class="alert alert-warning" role="alert" id="slot_book_lock">
                  <div class="input-group">
                    <p>By clicking PAY this voucher you will be taken to a new window to purchase your voucher.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <img
              v-if="paymentProvider == 'Paymentsense' || paymentProvider == 'Paymentsense ConnectE'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_ps.png"
              alt="Payment Method Accepted">
            <img
              v-else-if="paymentProvider == 'Stripe'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_stripe.png"
              alt="Payment Method Accepted">
            <img
              v-else-if="paymentProvider == 'Square'"
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_square.png"
              alt="Payment Method Accepted">
            <img
              v-else
              class="img-fluid"
              style="margin: 0 auto;"
              src="/img/payment/payments_testing.png"
              alt="Payment Method Accepted">
          </div>
        </div>
      </div>
    </div>
    <!-- .modal confirmModal-->

    <!-- ALL MODALS ABOVE -->
    <!-- WEB-VISIBLE CODE BELOW -->

    <template v-if="expiry">
      <h4 class="pt-4 mb-0 text-left">Gift Vouchers have an expiry of {{ expiryText }}<span v-if="voucherUniversal"> and can be used in all {{ brand }} branches</span>.</h4>
      <hr class="border-white">
    </template>

    <template v-if="playerVouchersAvailable.length">
      <h2 class="pt-4 pb-2 text-center text-uppercase font-weight-bold">Player Vouchers</h2>
      <p class="mb-0 text-left">&bull; Complete payment for <template v-if="$deploymentIs('rushden')">games at Rushden</template><template v-else-if="voucherUniversal">our</template><template v-else>{{ location.name }}’s</template> games</p>
      <p class="mb-0 text-left">&bull; Vouchers can be used for larger group sizes, the difference in cost will need to be paid on redemption.</p>
      <p v-if="$deploymentIs('escapable')" class="mb-0 text-left">&bull; The Great Loudini is a more expensive game, player vouchers redeemed for this game will have an additional fee to pay.</p>

      <div class="row" id="roomVoucher">
        <template v-for="voucher in playerVouchersAvailable">
          <div class="col-sm-6 col-md-4" :class="playerVouchersAvailable.length == 5 ? 'col-lg-4' : 'col-lg-3'">
            <div class="generic-voucher mx-auto" :class="'generic-voucher-' + $deploymentCurrent" @click="voucherFor(voucher.amount, true)">
              <div class="price">Group of {{ voucher.amount }}</div>
              <div class="title my-1" @click="voucherFor(voucher.amount, true)">
                <button class="btn btn-dark-green">{{ calculatePlayerVoucherCashEquivalent(voucher.amount, true) | money }}</button>
              </div>
              <small v-if="$deploymentIs('escapable') && voucher.amount > 6">Only For Outatime</small>
            </div>
          </div>
        </template>
      </div>
    </template>

    <template v-if="peakOffPeakVouchersAvailable.length"> <!-- PEAK & OFF-PEAK -->
      <div class="py-4" id="roomVoucher">
        <h2 class="py-4 text-center text-uppercase font-weight-bold">Peak Person Vouchers</h2>
        <div class="row">
          <div v-for="voucher in peakVouchersAvailable" :class="$deploymentIs('cryptology') ? 'col-sm-6 col-md-4 col-lg-3' : 'col-sm-4'" @click="voucherFor(voucher.amount, true)">
            <div
              class="generic-voucher mx-auto"
              :class="'generic-voucher-' + $deploymentCurrent">
              <div class="price">Group of {{ voucher.amount }}</div>
              <div class="price" style="font-size: 20px;">Peak</div>
              <div class="title">{{ calculatePlayerVoucherCashEquivalent(voucher.amount, true) | money }}</div>
            </div>
          </div>
        </div>
        <h2 class="py-4 text-center text-uppercase font-weight-bold">Off-Peak Person Vouchers</h2>
        <div class="row">
          <div v-for="voucher in offPeakVouchersAvailable" :class="$deploymentIs('cryptology') ? 'col-sm-6 col-md-4 col-lg-3' : 'col-sm-4'" @click="voucherFor(voucher.amount, false)">
            <div
              class="generic-voucher mx-auto"
              :class="'generic-voucher-' + $deploymentCurrent">
              <div class="price">Group of {{ voucher.amount }}</div>
              <div class="price" style="font-size: 20px;">Off-Peak</div>
              <div class="title">{{ calculatePlayerVoucherCashEquivalent(voucher.amount, false) | money }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="fixedMonetaryVouchersAvailable"> <!-- FIXED-MONEY PRICES -->
      <div id="moneyVoucher" class="py-4">
        <h2 class="py-4 text-center text-uppercase font-weight-bold">Monetary Vouchers</h2>
        <p class="mb-0 text-left" :class="$deploymentIs('m4escapes') ? 'text-center' : ''">&bull; Cash equivalent voucher for <template v-if="voucherUniversal">our</template><template v-else>{{ location.name }}’s</template> experiences</p>
        <p class="mb-0 text-left" :class="$deploymentIs('m4escapes') ? 'text-center' : ''">&bull; Vouchers can be used to (part-)pay for any booking.</p>

        <div class="row">
          <div v-for="voucher in fixedMonetaryVouchersAvailable" :class="$deploymentIn(['levelup', 'makeyourescape']) ? 'col-sm-4' : 'col-sm-6 col-md-4 col-lg-3'" @click="resetCash(); addCash(voucher.amount); voucherCash()">
            <div class="generic-voucher mx-auto" :class="'generic-voucher-' + $deploymentCurrent">
              <div class="price">{{ voucher.amount | money }}</div>
              <div class="title">{{ voucher.amount | money }} Voucher</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-if="voucherCalculatorAmounts"> <!-- CREATE YOUR OWN MONEY VOUCHER -->
      <div class="pt-2 row" :id="$deploymentIs('cryptology') ? '' : 'moneyVoucher'">
        <div class="col-md-12">
          <h3 :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'">Order Gift Vouchers To The Value Of&hellip;</h3>
          <p :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'">Keep pressing until you get the amount you require</p>
        </div>
      </div>
      <div class="row" :class="$deploymentIs('missionclassified') ? 'bg-gray-800' : ''">
        <div v-for="voucherCalculatorAmount in sortedVoucherCalculatorAmounts" class="col-md text-center py-3" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
          <button
            type="button"
            :class="voucherTotal >= voucherCalculatorMax ? 'btn btn-lg btn-dark-red' : 'btn-dark-green button-' + $deploymentCurrent"
            :disabled="voucherTotal >= voucherCalculatorMax"
            @click="addCash(voucherCalculatorAmount)">
            {{ voucherCalculatorAmount | money }}
          </button>
        </div>
        <div class="col-md text-center py-3" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
          <button
            type="button"
            :class="$deploymentIs('cryptology') ? 'btn btn-lg btn-orange' : 'btn-red button-' + $deploymentCurrent"
            @click="resetCash()">
            Clear
          </button>
        </div>
      </div>
      <div class="row pt-3 pb-2" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
        <div class="col">
          <h3 class="text-right font-weight-bold">Voucher Total:</h3>
        </div>
        <div class="col">
          <h3 class="text-left font-weight-bold">{{ voucherTotal | money }}</h3>
        </div>
      </div>
      <div class="row mb-3" :class="$deploymentIs('missionclassified') ? 'bg-gray-800' : ''">
        <div class="col text-center py-4" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
          <button
            type="button"
            :class="purchaseVoucherClass"
            id="vouch_buy"
            @click="voucherCash()">
            Purchase Voucher
          </button>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <p :class="$deploymentIs('cryptology') ? 'font-mon' : 'font-weight-bold'">If you have a voucher you wish to redeem against a booking, please redeem through the checkout, call us, or email us to arrange.</p>
          <p v-if="$deploymentIs('breakescape')" class="font-weight-bold">To upgrade to a physical voucher please use the button below to contact us or email us at <a href="mailto:play@breakescape.co.uk ">play@breakescape.co.uk</a></p>
          <p v-if="$deploymentIs('breakescape')" class="font-weight-bold">Please include the voucher value you’d like and the postal address where you want the voucher to be sent.</p>
          <p v-if="$deploymentIs('breakescape')">* Physical vouchers are charged at standard rate plus {{ 300 | money }} for postage & processing.</p>
          <p v-if="$deploymentIs('breakescape')">* All vouchers are sent out First Class with Royal Mail within 2 days of purchase.</p>
        </div>
      </div>
    </div>

    <pay-handler
      ref="payComponent"
      :location="location"/>
  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    locationVoucherProducts: {
      type: Array,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'V',
    },
    locationDiscount: {
      type: Object,
    },
    postCutoff: {
      type: String,
      default: '2023-12-16T23:59:59Z',
    },
    brand: {
      type: String,
      default: 'Cryptology',
    },
    sellPostalVoucher: {
      type: Boolean,
      default: true,
    },
    collectVoucher: {
      type: Boolean,
      default: false,
    },
    paymentProvider: {
      type: String,
    },
    expiry: {
      type: Number,
    },
    voucherUniversal: {
      type: Boolean,
      default: false,
    },
    voucherCalculatorAmounts: {
      type: Array,
    },
    voucherCalculatorMax: {
      type: Number,
      default: 100000,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
  },

  data() {
    return {
      startTime: null, // fraud|bot check

      customerId: null,
      payButtonDisable: false,

      // bookModal v-models
      email: null,
      name: null,
      username: null, // for spam detection
      contactNumber: null,
      discount: null,
      sendBy: 'E',
      type: null,
      amount: null,

      postAddress: null,

      sendToCustomer: true,
      recipientEmail: null,
      recipientName: null,
      recipientAddress: null,
      recipientMessage: null,

      // validation errors
      emailError: false,
      emailSoftError: false,
      nameError: false,
      discountError: false,
      postAddressError: false,
      recipientEmailError: false,
      recipientEmailSoftError: false,
      recipientNameError: false,

      numberOfPlayers: 0,
      voucherTotal: 0,
      isPeak: true,

      customerId: null,
      customerName: null,
      customerEmail: null,

      asPendingError: false,

      state: null,
    };
  },

  computed: {
    hasPeak() {
      return this.listedVoucherProducts.some(lvp => lvp.type == 'O');
    },

    listedVoucherProducts() {
      return this.locationVoucherProducts.filter(lvp => lvp.state == 'LISTED');
    },

    playerVouchersAvailable() {
      if (this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'P');

      // if (this.$deploymentCurrent && this.location.id == 2) {
      //   return false;
      // }
      // return this.$deploymentIn([
      //   'taketheexit',
      //   'bridlington',
      //   'escapestaging',
      //   'kanyu',
      //   'escapable',
      //   'crypticescape',
      //   'paralysis',
      //   'rushden',
      //   'escapereading',
      //   'panicroomharlow',
      //   'axefactor',
      //   'escaporium',
      //   'operationescape',
      //   'levelup',
      //   'topescaperooms',
      // ]);
    },

    peakOffPeakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type != 'M');

      // return this.$deploymentIn([
      //   'cryptology',
      //   'beyondbreakout',
      //   'horrorescape',
      // ]);
    },

    peakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'P');
    },

    offPeakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'O');
    },

    fixedMonetaryVouchersAvailable() {
      return this.listedVoucherProducts.filter(lvp => lvp.type == 'M').sort((a, b) => a.amount - b.amount);

      // return this.$deploymentIn([
      //   'breakescape',
      //   'levelup',
      //   'kanyu',
      //   'cryptology',
      //   'taketheexit',
      //   'bridlington',
      //   'cypherquest',
      //   'wisbech',
      //   'makeyourescape',
      //   'the-real-escape',
      //   'beyondbreakout',
      //   'escapable',
      //   'escapereading',
      //   'escapegoat',
      //   'rushden',
      //   'panicroomharlow',
      //   'axefactor',
      //   'm4escapes',
      //   'escapetime',
      //   'escaporium',
      //   'operationescape',
      // ]);
    },

    customMonetaryVouchersAvailable() {
      // using here to check deployments, this can be removed.
      return this.$deploymentIn([
        'cryptology', // 10, 20
        'taketheexit', // 10, 20
        'breakescape', // 10, 20
        'coalville', // 10, 20
        'missionclassified', // 1, 10, 20
        'escapable', // 1, 10, 20
        'panicroomharlow', // 5, 10, 20
        'topescaperooms', // 5, 10, 20
      ]);
    },

    fixedMonetaryVoucherAmounts() {
      // using here to check deployments, this can be removed.
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return [20, 50, 80, 100];
        case 'taketheexit':
        case 'bridlington':
        case 'kanyu':
        case 'escapable':
          return [20, 50, 75, 100];
        case 'breakescape':
          return [25, 50, 75, 100];
        case 'the-real-escape':
          return [20, 25, 50, 60, 75, 80, 100, 120];
        case 'cypherquest':
        case 'wisbech':
          return [10, 25, 50, 75, 100, 125];
        case 'beyondbreakout':
          return [20, 50, 75, 100, 120];
        case 'escapereading':
        case 'missionclassified':
        case 'operationescape':
          return [20, 25, 30, 40, 50, 60, 75, 100];
        case 'escapegoat':
          return [10, 15, 20, 25, 30, 40, 50, 60, 80, 100, 150, 200, 240];
        case 'rushden':
          return [10, 20, 30, 40, 50, 75, 100];
        case 'topescaperooms':
          return [10, 20, 30, 40, 50, 75, 100];
        case 'panicroomharlow':
          return [5, 10, 20, 50, 75, 100, 120, 150];
        case 'axefactor':
        case 'escaporium':
          return [10, 20, 30, 40, 50, 75, 100];
        case 'm4escapes':
          return [10, 20, 25, 50, 60, 75, 80, 100, 120];
        case 'escapetime':
          return [10, 20, 25, 50, 60, 75, 100, 120];
        default:
          return [20, 25, 50, 75, 100];
      }
    },

    sortedVoucherCalculatorAmounts() {
      return this.voucherCalculatorAmounts.sort((a, b) => a - b);
    },

    /**
     * Text for the voucher type
     * @return {string}
     */
    voucherDescription() {
      if (this.numberOfPlayers == 0) {//is a money voucher
        this.type = 'M';
        this.amount = this.voucherTotal;
        return 'Voucher for ' + this.$money(this.voucherTotal);
      } else {
        this.amount = this.numberOfPlayers;
        if (this.isPeak) {
          this.type = 'P';
          return 'Peak Voucher for ' + this.numberOfPlayers + ' players';
        } else {
          this.type = 'O';
          return 'Off-Peak Voucher for ' + this.numberOfPlayers + ' players';
        }
      }
    },

    voucherPreDiscountedTotal() {
      if (this.numberOfPlayers == 0) {//is a money voucher
        return this.voucherTotal;
      } else {
        return this.getPrice(this.numberOfPlayers,this.isPeak)
      }
    },

    purchaseVoucherClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'btn btn-lg btn-primary';
        case 'breakescape':
          return 'button-breakescape';
        default:
          return 'btn-primary button-' + this.$deploymentCurrent;
      }
    },

    isDecember() {
      // we only want this message displaying until Xmas Day, it is then irrelevant
      return (moment().format('M') == 12 && moment().format('D') < 25);
    },

    isAfterPostCutoff() {
      // this confirms if it is before the cutoff
      // var splitDate = this.postCutoff.split('.')[0].slice(1);
      var theDate = moment(this.postCutoff);
      return moment().isAfter(theDate);
    },

    postCutoffString() {
      return moment(this.postCutoff).format('dddd, Do MMMM YYYY, h:mm a');
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    inPromo() {
      if (this.locationDiscount) {
        if (moment().isBetween(moment(this.locationDiscount.valid_from), moment(this.locationDiscount.expiry))) {
          return true;
        }
      }

      return false;
    },

    voucherPostDiscountedTotal() {
      if (this.inPromo) {
        return this.voucherPreDiscountedTotal * ((100 - parseInt(this.locationDiscount.percentage))/100);
      } else {
        return this.voucherPreDiscountedTotal;
      }
    },

    sendType() {
      if (this.sendBy == 'P') {
        return 'Post';
      }
      return 'Email';
    },

    contactNumberError() {
      if (this.contactNumber === null) {
        return null;
      } else {
        if (this.contactNumber == '***** ******') {
          return null;
        } else {
          if (this.contactNumber
            .match(/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/)
            ) {
            return null;
          } else {
            return 'Invalid phone number.';
          }
        }
      }
    },

    contactRoute() {
      return this.location.locationContactHref;
    },

    expiryText() {
      if (this.expiry) {
        if (this.expiry < 12) {
          return this.expiry + ' months';
        } else if (this.expiry == 12) {
          return '1 year';
        } else if (this.expiry == 18) {
          return '18 months';
        } else {
          return (this.expiry / 12).toString() + ' years';
        }
      }
      return null;
    }
  },

  methods: {
    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

    calculatePlayerVoucherCashEquivalent(players, calculateForPeak = true) {
      return this.getPrice(players,calculateForPeak)
    },

    voucherFor(numPlayers, isPeak) {
      this.voucherTotal = 0; // reset this
      this.numberOfPlayers = numPlayers;
      this.isPeak = isPeak;

      this.showVoucherModal();
    },

    voucherCash() {
      this.numberOfPlayers = 0; // reset
      this.isPeak = true; // reset

      if (this.voucherTotal == 0) {
        flash('No voucher amount chosen to purchase.','danger');
      } else {
        this.showVoucherModal();
      }
    },

    addCash(amount) {
      this.voucherTotal += amount;
    },

    resetCash() {
      this.voucherTotal = 0;
    },

    showVoucherModal() {
      // Do any prep before showing the modal

      this.startTime = moment(); // fraud|bot check

      this.state = 'PURCHASING';
      $(this.$refs.voucherModal).modal('handleUpdate');
      $(this.$refs.voucherModal).modal('show');
    },

    hideVoucherModal() {
      $(this.$refs.voucherModal).modal('hide');
    },

    showRecipientModal() {
      $(this.$refs.recipientModal).modal('show');
    },

    hideRecipientModal() {
      $(this.$refs.recipientModal).modal('hide');
    },

    voucherModalHidden() {
      // console.log('voucherModalHidden');
      this.emailError = false;
      this.emailSoftError = false;
      this.nameError = false;
      this.discountError = false;
    },

    getPrice(num_players, peak) { // this is pre-discount
      // find out whether it is a peak day or not
      let price = this.location.prices.find(price => price.price_for == num_players);

      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (peak) {
          return price.peak * num_players;
        } else {
          return price.offpeak * num_players;
        }
      } else {
        if (peak) {
          return price.peak;
        } else {
          return price.offpeak;
        }
      }
    },

    resetVoucherModalInputs() {
      // this.email = null;
      // this.name = null;
      // this.contactNumber = null;
      // this.discount = null;
    },

    emailBlur() {
      // console.log('emailBlur');
      if (this.customerId !== null && this.email != this.customerEmail) {
        // console.log('emailBlur:forget');
        // you changed the emil address, forgot who we though you where
        this.customerId = null;
        this.customerEmail = null;
        this.customerName = null;
      }

      if (this.email && (this.name == null || this.name == '')) {

        this.emailError = false;
        this.emailSoftError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
          return;
        }
        // console.log('emailBlur:pre searchEmail');
        this.loading(true, this.$refs.voucherModal);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              this.customerId = customerFound.id;
              this.customerEmail = this.email;
              this.customerName = customerFound.name;
              this.name = this.customerName;
              this.contactNumber = '***** ******';
            } else {
              this.$refs.nameInput.focus();
              this.checkRegionalEmail();
            }
          });
      }
    },

    async searchEmail(emailToSearch) {
      let request = {
        email: emailToSearch,
      }

      try {
        const response = await axios.post(this.route('api.customers.email-lookup'), request);
        if (response.status == 200) {
          return response.data;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status == 422) { // HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            this.emailError = error.response.data.errors.email[0]; // Please enter a valid email address.
          } else if (error.response.status == 404) {
            this.customerId = null;
            this.customerEmail = null;
            this.customerName = null;
          }
          // console.log('emailBlur: Response error', error.response.data, error.response.status, error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.error('emailBlur: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('emailBlur: Error', error.message);
        }
      }

      return null;
    },

    recipientDetailsClick() {
      // validation
      if (this.email == null || this.email == '') {
        this.emailError = 'An email address is required.'; // Please enter a valid email address.
        return false;
      }
      if (this.name == null || this.name == '') {
        this.nameError = 'A name is required.';
        return false;
      }

      // hide our modal
      this.hideVoucherModal();
      // ask the confirm modal to show
      this.showRecipientModal();
    },

    backToVoucherModal() {
      // hide our modal
      this.hideRecipientModal();
      // ask the confirm modal to show
      this.showVoucherModal();
    },

    checkRegionalEmail() {
      var regex = /^[\w.+\-]+@([a-zA-Z0-9]+)([\.])(com|co.uk)/gm;
      if (regex.test(this.email)) {
        this.emailSoftError = false;
      } else {
        this.emailSoftError = 'Warning: Email does not end in .co.uk or .com. You may proceed with the booking, this is to highlight you have a non-standard email, or a typo.';
      }
    },

    confirmPriceClick() {
      if (this.contactNumberError) {
        const self = this;

        let options = {
          container: 'body',
          rootSelector: '#voucherSaleConfirmPriceBtn',
          title: 'Proceed with unrecognised phone number format?',
          popout: true,
          singleton: true,
          btnOkLabel: 'Continue',
          btnOkClass: 'btn btn-success',
          btnOkIconClass: 'material-icons',
          btnOkIconContent: 'shopping_cart',
          btnCancelLabel: 'Stop!',
          btnCancelClass: 'btn btn-danger',
          btnCancelIconClass: 'material-icons',
          btnCancelIconContent: 'close',
          onConfirm(value) {
            self.confirmPriceConfirmed();
          },
        };

        $('#voucherSaleConfirmPriceBtn').confirmation(options);

        $('#voucherSaleConfirmPriceBtn').confirmation('show');
      } else {
        this.confirmPriceConfirmed();
      }
    },

    confirmPriceConfirmed() {
      // console.log('confirmPriceConfirmed');

      // Anti-fraud
      if (moment().diff(this.startTime, 'seconds') < 2) {
        // this is too quick, abort
        this.hideVoucherModal();
        flash('Contact us if you are having issues.', 'danger');

        return false;
      }

      // Anti-fraud #2
      if (this.username !== null) {
        // a bot has filled in the username
        this.hideVoucherModal();
        flash('Contact us if you are having issues.', 'danger');

        return false;
      }

      // Validation
      if (! this.sendToCustomer) {
        // the extra steps to validate the extra details
        if (this.recipientEmail == null || this.recipientEmail == '') {
          this.recipientEmailError = 'An email address is required.'; // Please enter a valid email address.
          flash('An email address is required.', 'danger');
        } else {
          this.recipientEmailError = false;
        }

        if (this.recipientName == null || this.recipientName == '') {
          this.recipientNameError = 'A recipient name is required.';
          flash('A recipient name is required.', 'danger');
        } else {
          this.recipientNameError = false;
        }
      }

      if (this.sendBy == 'P') {
        if (this.postAddress == null || this.postAddress == '') {
          this.postAddressError = 'You must fill in the address for us to post this gift voucher.'
          flash('You must fill in the address for us to post this gift voucher.', 'danger');
        } else {
          this.postAddressError = false;
        }
      }

      if (this.email == null || this.email == '') {
        this.emailError = 'An email address is required.'; // Please enter a valid email address.
          flash('An email address is required.', 'danger');
      } else {
        this.emailError = false;

        try {
          new Address(this.email);
        } catch (error) {
          this.emailError = error.message; // Please enter a valid email address.
          flash('An enter a valid email address.', 'danger');
        }

        // TODO: try looking up the email again?
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // LWK what to do?
              this.customerId = customerFound.id;

              if (this.name != customerFound.name || this.contactNumber != '***** ******') {
                // should we update the Customer details?
                // this.updateCustomer();
              }
            }
          });

      }

      if (this.name == null || this.name == '') {
        this.nameError = 'Please enter your name.';
        flash('Please enter your name.', 'danger');
      } else {
        this.nameError = false;
      }

      // if (this.contactNumber == '') {
      //   this.contactNumberError = 'A contact number is required, please resolve.';
      // } else {
      //   this.contactNumberError = false;
      // }

      // if (this.discount == '') {
      //   this.discountError = 'Invalid discount code.';
      // } else {
      //   this.discountError = false;
      // }

      if (this.emailError
        || this.nameError
        || this.discountError
        || this.postAddressError) {
        flash('There are error(s) that need to be fixed.', 'danger');

        return;
      }

      // hide our modal
      this.hideVoucherModal();
      this.hideRecipientModal();
      // ask the confirm modal to show
      this.showConfirmModal();
    },

    /*
     * END bookModal methods
     * =============== */

    /* ===============
     * confirmModal methods
     */

    showConfirmModal() {
      // Do any prep before showing the modal
      this.payButtonDisable = false;
      this.asPendingError = false;

      this.state = 'CONFIRMING';
      $(this.$refs.confirmModal).modal('handleUpdate');
      $(this.$refs.confirmModal).modal('show');
    },

    hideConfirmModal() {
      $(this.$refs.confirmModal).modal('hide');
    },

    confirmModalHidden() {
      // console.log('confirmModalHidden');
      if (this.asPendingError) {
        this.$emit('refetch'); // tell the BookingCalendar it needs to refetch the RoomSlots
      }
    },

    payButtonClicked() {
      // console.log('payButtonClicked');
      this.payButtonDisable = true;

      // time to create the customer if they where not found by look up

      if (this.customerId && (this.name != this.customerName || this.contactNumber != '***** ******')) {
        // customer has edit their details, what todo?
      }

      if (this.customerId == null) {
        this.loading(true);
        this.searchEmail(this.email)
          .then(customerFound => {
            this.loading(false);
            if (customerFound !== null) {
              // hmm
              this.customerId = customerFound.id;
              this.makeVoucherAsPending();
            } else {
              this.loading(true);
              this.storeCustomer()
                .then(newCustomer => {
                  this.loading(false);
                  if (newCustomer) {
                    this.customerId = newCustomer.id;
                    this.makeVoucherAsPending();
                  } else {
                    console.log('payButtonClicked: storeCustomerError')
                    flash('Unable to store customer.');
                    this.payButtonDisable = false;
                    return; // some kind of error cause we failed to create the customer
                  }
                });
            }
          });
      } else {
        // console.log('buy voucher');
        this.makeVoucherAsPending();
      }
    },

    async storeCustomer() {
      // console.log('storeCustomer');
      // create the customer
      let request = {
        email: this.email,
        name: this.name,
        number: this.contactNumber,
        location_id: this.location.id,
      }

      try {
        const response = await axios.post(this.route('api.customers.store'), request)
        if (response.status == 200) {
            return response.data;
        } else {
          flash('Error creating customer', 'danger');
          console.log('storeCustomer', response.data);
          console.log('storeCustomer', response.status);
          console.log('storeCustomer', response.statusText);
        }
      } catch (error) {
        // flash('Error creating customer', 'danger');
        if (error.response) {
          if (error.response.status == 422) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            console.log('storeCustomer:422', error.response.data);
            if (error.response.data.errors.number) {
              this.loading(false);
              flash('Phone number invalid, cannot proceed ' + error.response.data.errors.number[0]);
              this.hideConfirmModal();
              this.showVoucherModal();
              this.$ref.customerTelephoneInput.focus();
            } else {
              this.loading(false);
              flash('Unable to store customer. Please contact the branch.');
              this.hideConfirmModal();
              this.showVoucherModal();
            }
          } else if (error.response.status == 409) {
            // else if HTTP_CONFLICT
            console.log('storeCustomer:409', error.response.data);
          } else if (error.response.status == 403) {
            // else if HTTP_FORBIDDEN on enough permissions
            console.log('storeCustomer:403', error.response.data);
          } else if (error.response.status == 401) {
            // else if HTTP_UNAUTHORIZED not authorized
            console.log('storeCustomer:401', error.response.data);
            window.location.reload();
          } else {
            console.log('storeCustomer: Response error', error.response.data, error.response.status, error.response.headers);
          }

        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.error('storeCustomer: Request error', error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('storeCustomer: Error', error.message);
        }
      }

      return null;
    },

    makeVoucherAsPending() {
      let request = {
        customer_id: this.customerId,
        location_id: this.location.id,
        send_by: this.sendBy,
        type: this.type,
        notes: '',
        amount: this.amount,
        sold_for: this.voucherPostDiscountedTotal,
        from: 'V',

        recipient_message: this.recipientMessage,
        send_to_email: this.recipientEmail,
        send_to_address: this.postAddress,
        send_to_name: this.recipientName
      }
      // console.log('makeVoucherAsPending request', request);

      this.loading(true);
      axios.post(this.route('api.vouchers.store'), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {
            let newVoucher = response.data;

            // console.log('axios response:', newVoucher);

            // move on to take payment
            this.hideConfirmModal();

            // console.log('Moving to take payment');
            this.state = 'TAKING_PAYMENT';
            this.$nextTick(() => {
              this.$refs.payComponent.takeVoucherPayment(newVoucher);
            });
          } else {
            flash('Error creating Voucher:PENDING', 'error');
            console.log('makeVoucherAsPending', response.data);
            console.log('makeVoucherAsPending', response.status);
            console.log('makeVoucherAsPending', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error making pending Voucher', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('makeVoucherAsPending:422', error.response.data);
            } else if (error.response.status == 409 && error.response.data.message == 'Blocklist email') {
              // else if HTTP_CONFLICT && Blocklist Email
              $(this.$refs.confirmModal).modal('hide');
              $(this.$refs.loadingModal).modal('show');
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('makeVoucherAsPending:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('makeVoucherAsPending:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('makeVoucherAsPending:401', error.response.data);
              window.location.reload();
            } else {
              console.log('makeVoucherAsPending: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('makeVoucherAsPending: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('makeVoucherAsPending: Error', error.message);
          }
          this.loading(false);
        }); // axios
    },
    /*
     * END confrimModal methods
     * =============== */
  },

  mounted() {
    $(this.$refs.voucherModal).on('hidden.bs.modal', this.voucherModalHidden);
    $(this.$refs.confirmModal).on('hidden.bs.modal', this.confirmModalHidden);
  },
}

</script>
